/**
 * Revision Utility Functions
 * Handles API calls and data transformations for Revisions
 */

function payloadRevision(data) {
    let payload = {};
    payload.idAbout = data.idAbout;
    payload.description = data.description;
    if (data.report !== 'undefined') {
        payload.report = data.report;
    }
    return payload;
}

function dataRevision(data) {
    return data;
}

export const getRevision = (dsd, id, onLoad, onFail) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.get(`/revisions/${id}`, headers)
        .then(response => {
            if (onLoad) {
                onLoad(dataRevision(response.data));
            }
        })
        .catch(e => {
            if (onFail) {
                onFail(e);
            }
            console.error('Failed to get revision:', e);
        });
};

export const listRevisions = (dsd, Filters = {}, onLoad, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/revisions";
    if (Object.keys(Filters).length > 0) {
        urlAPI += "?";
    }

    if (Filters.idUser) {
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.idAbout) {
        urlAPI += `idAbout=${encodeURIComponent(Filters.idAbout)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos = 0; pos < response.data.length; pos++) {
                arr.push(dataRevision(response.data[pos]));
            }
            if (onLoad) {
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to list revisions:', e);
        });
};

export const addRevision = (dsd, idAbout, Data = {}, onSuccess, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    Data.idAbout = idAbout;
    let payload = payloadRevision(Data);

    dsd.httpConfig.post(`/revisions`, payload, headers)
        .then(response => {
            if (onSuccess) {
                onSuccess(response.data._id);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to add revision:', e);
        });
};

export const editRevision = (dsd, id, Data = {}, onSuccess, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadRevision(Data);

    dsd.httpConfig.put(`/revisions/${id}`, payload, headers)
        .then(response => {
            if (onSuccess) {
                onSuccess();
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to edit revision:', e);
        });
};

export const deleteRevision = (dsd, id, onSuccess, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/revisions/${id}`, headers)
        .then(response => {
            if (onSuccess) {
                onSuccess();
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to delete revision:', e);
        });
};
